import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  LinearProgress,
  Link,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import React, { Fragment, useState } from 'react'
import { ProductOriginsDDL } from '../../../components/Producto/ProductOrigins/ProductOriginsDDL'
import { HelpIcon } from '../../../components/_WMS/HelpIcon/HelpIcon'
import { useApi } from '../../../hooks/useApi'
import {
  getUpdatePreSaleSkuTemplate,
  postUpdatePreSaleSkuMasiveFile
} from '../api'

interface EditPreSaleSkuMasiveModalProps {
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  requestWorkOrderRecall: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 15,
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: '#EEEEEE'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }
}))(LinearProgress)

export const EditPreSaleSkuMasiveModal: React.FC<
  EditPreSaleSkuMasiveModalProps
> = ({ handleSnackbar, handleCloseModal, requestWorkOrderRecall }) => {
  const [currentFile] = useState<any | undefined>(undefined)
  const [progress, setProgress] = useState<number>(0)
  const [checkIsInfiniteQty, setCheckIsInfiniteQty] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )
  const [selectedProductOrigins, setSelectedProductOrigins] =
    useState<number>(0)
  const { state: requestLabelState, callApi: requestDownloadTemplate } =
    useApi()
  const { state, callApi } = useApi()

  const handleSetProductOrigin = (id: number) => {
    setSelectedProductOrigins(id)
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
  }

  const handleChkQuality = () => {
    setCheckIsInfiniteQty(!checkIsInfiniteQty)
  }

  const validateButtonLoad = () => {
    if (!selectedFiles || selectedProductOrigins <= 0) return true
    else return false
  }

  const handleSubmit = () => {
    const formData = new FormData()

    // Agregar los valores del formulario
    formData.append('brandId', `${selectedProductOrigins}`)
    formData.append('isInfiniteQty', `${checkIsInfiniteQty}`)

    // Agregar el archivo seleccionado
    if (selectedFiles && selectedFiles.length > 0)
      formData.append('file', selectedFiles[0])

    callApi(postUpdatePreSaleSkuMasiveFile(formData))
      .then(() => {
        handleSnackbar('Carga realizada exitosamente', true)
        requestWorkOrderRecall()
        handleCloseModal()
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
  }

  const handleDownloadTemplate = () => {
    requestDownloadTemplate(getUpdatePreSaleSkuTemplate())
      .then((response) => {
        const raw = window.atob(response.file)
        const uInt8Array = new Uint8Array(raw.length)
        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }
        const link = document.createElement('a')
        const blob = new Blob([uInt8Array], {
          type: response.mimeType
        })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', response.name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
  }

  if (
    state.status === Status.Loading ||
    requestLabelState.status === Status.Loading
  ) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Fragment>
        <Grid
          container
          spacing={2}
          justifyContent='space-around'
          alignItems='center'
          style={{ textAlign: 'center', marginBottom: '3px' }}
        >
          <Grid
            item
            xs={6}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <ProductOriginsDDL
              onChange={(e: any) =>
                handleSetProductOrigin(e.target.value as number)
              }
              value={selectedProductOrigins}
              required={true}
              type='outlined'
              size='small'
            />
          </Grid>
          <Grid
            item
            xs={6}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  size='medium'
                  color='primary'
                  onChange={() => handleChkQuality()}
                />
              }
              label='Stock Infinito'
            />
          </Grid>
        </Grid>
        <br />
        <hr />
        <Box className='mb25' display='flex' alignItems='center'>
          <Grid
            container
            spacing={4}
            direction='row'
            alignItems='center'
            justifyContent='center'
            style={{ justifyContent: 'center' }}
          >
            <Grid item xs={3} style={{ textAlign: 'right' }}>
              <label htmlFor='btn-upload'>
                <input
                  id='btn-upload'
                  name='btn-upload'
                  style={{ display: 'none' }}
                  type='file'
                  onChange={handleSelectFile}
                  accept='.xls,.xlsx'
                />
                <Tooltip
                  title='Seleccionar el archivo Excel a cargar'
                  placement='top-end'
                >
                  <Button
                    className='btn-choose'
                    variant='outlined'
                    component='span'
                  >
                    Seleccionar Archivo
                  </Button>
                </Tooltip>
              </label>
            </Grid>

            <Grid item xs={5}>
              <Box
                display='flex'
                justifyContent='flex-start'
                alignItems='center'
              >
                <Typography noWrap style={{ maxWidth: '100%' }}>
                  {selectedFiles && selectedFiles.length > 0
                    ? selectedFiles[0].name
                    : ''}
                </Typography>
              </Box>
            </Grid>

            <Tooltip
              title='Enviar el archivo seleccionado al servidor para su procesamiento'
              placement='top'
            >
              <span style={{ display: 'inline-block' }}>
                <Button
                  className='btn-upload'
                  color='primary'
                  variant='contained'
                  component='span'
                  disabled={validateButtonLoad()}
                  onClick={handleSubmit}
                >
                  Cargar
                </Button>
              </span>
            </Tooltip>

            <Grid
              item
              xs={1}
              alignContent='center'
              style={{ textIndent: '15px' }}
            >
              <HelpIcon
                helperText={
                  'Oprima el botón SELECCIONAR para elegir el archivo a subir y luego el botón CARGAR para enviar el archivo al servidor para su procesamiento'
                }
                placement='top-end'
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              style={{ padding: '0px', marginBottom: '1px' }}
            >
              <ListItemText
                primary={''}
                secondary={
                  <Box>
                    <Typography component='ol' style={{ listStyle: 'square' }}>
                      <Typography
                        variant='subtitle1'
                        component='li'
                        gutterBottom
                      >
                        Puede descargar una <b>plantilla</b> desde el link que
                        se encuentra disponible a continuación.
                        <br />
                        <Link
                          style={{ cursor: 'pointer' }}
                          onClick={handleDownloadTemplate}
                        >
                          Descargar Template
                        </Link>
                      </Typography>
                    </Typography>
                  </Box>
                }
              />
            </Grid>
          </Grid>
        </Box>

        <div
          style={{
            margin: '2px',
            visibility: currentFile ? 'visible' : 'hidden'
          }}
        >
          <BorderLinearProgress variant='determinate' value={progress} />

          <Box minWidth={35}>
            <Typography
              variant='body1'
              color='textSecondary'
              style={{ textAlign: 'end' }}
            >{`${progress}%`}</Typography>
          </Box>
        </div>
      </Fragment>
    )
  }
}
